import React from "react";
import moment from 'moment';
import InputReadOnly from '../../../InputReadOnly';
const PeriodQuestionInput = (props) => {
    var _a, _b;
    return React.createElement(InputReadOnly, { label: `${props.title ? props.title : ""}`, content: `${moment((_a = props.currentValue) === null || _a === void 0 ? void 0 : _a.start).format("DD/MM/YYYY")} - ${moment((_b = props.currentValue) === null || _b === void 0 ? void 0 : _b.end).format("DD/MM/YYYY")}` });
};
export default PeriodQuestionInput;
